import { Activity, Binary, ShieldCheck, Users } from 'lucide-react';
import type { AdminSnapshot } from '../types';

interface OverviewFeatureProps {
  readonly snapshot: AdminSnapshot;
}

export function OverviewFeature({ snapshot }: OverviewFeatureProps) {
  const activeUsers = snapshot.users.filter((user) => user.active).length;
  const activeSequences = snapshot.numberSequences.filter((sequence) => sequence.active).length;

  const metrics = [
    { label: 'Aktive Benutzer', value: activeUsers, detail: `${snapshot.users.length} insgesamt`, icon: Users },
    { label: 'Rollen', value: snapshot.roles.length, detail: 'pro Mandant getrennt', icon: ShieldCheck },
    { label: 'Nummernkreise', value: activeSequences, detail: `${snapshot.numberSequences.length} eingerichtet`, icon: Binary },
    { label: 'Audit-Einträge', value: snapshot.audit.length, detail: 'letzte Aktivitäten', icon: Activity },
  ];

  return (
    <section className="admin-feature" aria-labelledby="admin-overview-title">
      <div className="admin-feature__heading">
        <div>
          <span className="admin-eyebrow">Systemüberblick</span>
          <h2 id="admin-overview-title">Mandant sauber eingerichtet</h2>
        </div>
        <span className="admin-generated">Stand {new Date(snapshot.generatedAt).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}</span>
      </div>

      <div className="admin-metric-grid">
        {metrics.map(({ label, value, detail, icon: Icon }) => (
          <article className="admin-metric" key={label}>
            <span className="admin-metric__icon"><Icon size={18} /></span>
            <strong>{value}</strong>
            <span>{label}</span>
            <small>{detail}</small>
          </article>
        ))}
      </div>

      <div className="admin-info-grid">
        <article className="admin-info-card">
          <span className="admin-eyebrow">Sicherheitsmodell</span>
          <h3>Doppelte Rechteprüfung</h3>
          <p>Die Oberfläche blendet nicht erlaubte Funktionen aus. Datenbank und Backend bleiben trotzdem die maßgebliche Sicherheitsgrenze.</p>
        </article>
        <article className="admin-info-card">
          <span className="admin-eyebrow">Mandantentrennung</span>
          <h3>Eigene Rollen und Nummern</h3>
          <p>Benutzer, Rollen, Ausnahmen, Nummernkreise und Audit werden für jede Firma getrennt verwaltet.</p>
        </article>
      </div>
    </section>
  );
}
